export enum StackFit {
  loose,
  expand,
  passthrough,
}
